import { createFileRoute } from "@tanstack/react-router";

import GatewayAuditPage from "@/features/dashboard/pages/gateway-audit";

export const Route = createFileRoute("/(app)/dashboard/gateway-audit")({
  component: () => <GatewayAuditPage />,
});
